import $ from "jquery";
import appInfo from './config';

  async function getSurvey(q) {
    const apiEndUrl = '/public/v2/survey/'+q.id
    return $.ajax({
      type: 'GET',
      url: appInfo.devServer + apiEndUrl,
      dataType: 'json',
    });
  }
  async function setSurvey(q) {
    const apiEndUrl = '/public/v2/survey'
    return $.ajax({
      type: 'POST',
      url: appInfo.devServer + apiEndUrl,
      contentType: "application/json; charset=utf-8",
      data: JSON.stringify(q)
    });
  }

  export default {
    getSurvey,
    setSurvey
  }